package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptableIndexable
import pl.decks.chartjs.radar.dataset.PointHoverProperties

@Suppress("unused")
@RadarDsl
class PointHoverScope {
    private var backgroundColor: JSScriptableIndexable<ChartColor>? = null
    private var borderColor: JSScriptableIndexable<ChartColor>? = null
    private var borderWidth: JSScriptableIndexable<Int>? = null
    private var radius: JSScriptableIndexable<Int>? = null

    fun backgroundColor(value: ChartColor) { backgroundColor = JSScriptableIndexable.Static(value) }
    fun backgroundColor(values: List<ChartColor>) { backgroundColor = JSScriptableIndexable.PerPoint(values) }
    fun backgroundColor(fn: (dynamic) -> ChartColor) { backgroundColor = JSScriptableIndexable.Scriptable(fn) }

    fun borderColor(value: ChartColor) { borderColor = JSScriptableIndexable.Static(value) }
    fun borderColor(values: List<ChartColor>) { borderColor = JSScriptableIndexable.PerPoint(values) }
    fun borderColor(fn: (dynamic) -> ChartColor) { borderColor = JSScriptableIndexable.Scriptable(fn) }

    fun borderWidth(value: Int) { borderWidth = JSScriptableIndexable.Static(value) }
    fun borderWidth(values: List<Int>) { borderWidth = JSScriptableIndexable.PerPoint(values) }
    fun borderWidth(fn: (dynamic) -> Int) { borderWidth = JSScriptableIndexable.Scriptable(fn) }

    fun radius(value: Int) { radius = JSScriptableIndexable.Static(value) }
    fun radius(values: List<Int>) { radius = JSScriptableIndexable.PerPoint(values) }
    fun radius(fn: (dynamic) -> Int) { radius = JSScriptableIndexable.Scriptable(fn) }

    internal fun build() = PointHoverProperties(
        backgroundColor = backgroundColor,
        borderColor = borderColor,
        borderWidth = borderWidth,
        radius = radius,
    )
}
